import React, { useEffect, useState } from "react";
import Sidebar from "@layouts/Sidebar";
import Header from "@layouts/Header";
import { cn } from "@lib/utils/tailwind";
import { Typography } from "@mui/material";
import { useAuth } from "@context/AuthContext";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();

  const [open, setOpen] = useState<boolean>(
    () => sessionStorage.getItem("sidebarOpen") === "true" || false
  );

  const handleDrawerToggle = () => {
    // const newOpenState = !open;
    // setOpen(newOpenState);
    // sessionStorage.setItem("sidebarOpen", String(newOpenState));
  };

  useEffect(() => {
    const savedState = sessionStorage.getItem("sidebarOpen");
    if (savedState !== null) {
      setOpen(savedState === "true");
    }
  }, []);

  return (
    <main className="flex h-screen w-screen overflow-hidden">
      {isAuthenticated && (
        <Sidebar open={open} handleDrawerToggle={handleDrawerToggle} />
      )}

      <section
        className={cn(
          "flex-1 flex flex-col min-h-screen transition-all overflow-y-auto duration-300",
          isAuthenticated ? "ml-0 lg:ml-64" : ""
        )}
      >
        {isAuthenticated && <Header />}
        <div className="flex-1 pt-5 px-6 overflow-y-auto">{children}</div>
      </section>
    </main>
  );
};

interface SectionHeadProps {
  title: string;
  className?: string;
  children?: React.ReactNode;
}

const SectionHead: React.FC<SectionHeadProps> = ({ title, children }) => {
  return (
    <div className="flex flex-1 flex-wrap items-center justify-between">
      <Typography
        variant="h4"
        sx={{ color: "primary.main", fontWeight: "bold" }}
      >
        {title}
      </Typography>
      <>{children}</>
    </div>
  );
};

interface SectionContentProps {
  children: React.ReactNode;
}

const SectionContent: React.FC<SectionContentProps> = ({ children }) => {
  return <>{children}</>;
};

export { Layout, SectionHead, SectionContent };
